import { useSideMenuChoice } from "features/app-layout/side-menu-choice/use-side-menu-choice.hook";

import LayoutSideMenu from "./layout-side-menu.component";
import LegacySideMenu from "./legacy/legacy-side-menu.component";

/**
 * ENG-2535: which side menu the layout mounts. The redesigned one while the
 * `sidebar-redesign` flag is on and the person has not switched back; the classic
 * rail otherwise. The choice hook is the only thing consulted, never the flag.
 */
export default function SideMenuSwitch() {
  const { useNew } = useSideMenuChoice();
  return useNew ? <LayoutSideMenu /> : <LegacySideMenu />;
}
